import { render, staticRenderFns } from "./FollowAndShareExternalUserSection.vue?vue&type=template&id=674a8fd2&scoped=true&"
import script from "./FollowAndShareExternalUserSection.vue?vue&type=script&lang=js&"
export * from "./FollowAndShareExternalUserSection.vue?vue&type=script&lang=js&"
import style0 from "./FollowAndShareExternalUserSection.vue?vue&type=style&index=0&id=674a8fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a8fd2",
  null
  
)

export default component.exports